import React, { useState, useEffect } from "react";
import { Field } from "formik";
import style from "./PatientDocUpload.module.css";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { object } from "yup";

const PatientDocUpload = (props) => {
  const [isScreenLoaded, setIsScreenLoaded] = useState(false);
  const [imageErr, setImageError] = useState("");
  const [inputList, setInputList] = useState([]);

  const [max_upload, setMaxUpload] = useState(
    localStorage.getItem("SETTING_INFO") &&
      JSON.parse(localStorage.getItem("SETTING_INFO")).max_upload
  );

  useEffect(() => {
    // if (props.values.isEditMode) {
    if (props.state.uploadDocs.length !== 0) {
      console.log("use effect", props.state.uploadDocs);
      setInputList(props.state.uploadDocs);
    }
    // }
  }, [props.state.isEditMode]);

  // Getting role of user
  let userData = JSON.parse(localStorage.getItem("USER_INFO"));

  // handle input change
  const handleInputChangeFile = (e, index) => {
    const { name, files } = e.target;

    if (files && files[0]) {
      var FileSize = files && files[0].size / 1024 / 1024; // in MB
      console.log("FileSize in MB ", FileSize);
      if (
        /\.(jpe?g|png|svg|pdf|txt)$/i.test(files && files[0].name) === false
      ) {
        setImageError("This type of file extension is not allowed");
        let uploadflag = true;
      } else {
        if (FileSize > 2.0) {
          setImageError("Please upload file less than 2MB!");
        } else {
          let uploadflag = false;
          setImageError("");

          const list = [...inputList];
          list[index][name] = files[0];
          list[index].isNewUpload = true;
          list[index].delete = false;
          setInputList(list);
         // setFieldValue("uploadDocs", [...list]);
          props.getUploadDocs([...list]);
        }
      }
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    //setFieldValue("uploadDocs", list);
    props.getUploadDocs([...list]);
  };
  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    setImageError("");
    const list = [...inputList];
    if (list[index].isNewUpload) {
      list.splice(index, 1);
    } else {
      list[index].delete = true;
    }
    setInputList(list);
   // setFieldValue("uploadDocs", list);
   props.getUploadDocs([...list]);
  };


  // handle click event of the Add button
  const handleAddClick = () => {
    setImageError("");
    setInputList([
      ...inputList,
      { selectedFile: "", description: "", isNewUpload: true, delete: false },
    ]);
  };


  setTimeout(() => {
    setIsScreenLoaded(true);
  }, 500);

  if (!isScreenLoaded) {
    return (
      <div className="dashboard-loader">
        <img src={ttmLoader} alt="loader" className="loader-image" />
      </div>
    );
  }

  return (
    <div className={style.uloadDocMainWrapper}>
      <div className={`form-controls-wrapper ${style.uploadDocFormWrapper}`}>
        {max_upload !== 0 && (
          <div>
            <div className="row">
              <div className="col-md-12">
                <h4>Upload Documents </h4>
                <p className={style.extensionAllowed}>
                  <small>You can upload maximum {max_upload} documents.</small>
                  <br />
                  <small>
                    Allowed extensions are .txt, .pdf, .png, .jpeg, .svg and max
                    limit size is 2MB
                  </small>
                </p>
              </div>
            </div>
            
            <div className="order-5 order-sm-5 order-md-5 col-sm-12 col-md-12 col-lg-12 col-xl-2">
                    {inputList.filter((item)=>item.delete !== true).length === 0 && (
                        <button
                          onClick={handleAddClick}
                          className={`${style.addBtn} ${style.singleAddBtn}`}
                        >
                          <i className="fa fa-plus mr-2" aria-hidden="true"></i>
                          Add
                        </button>
                      )}
            </div>
            {inputList &&
              inputList.map((x, i) => {
               return (!x.delete && (
                  <div className="box" key={i}>
                    <div className={`row ${style.mobileUploadDeocWrapper}`}>
                      <div className="col-8 col-sm-6 col-md-3 col-lg-1.5 col-xl-4">
                      {(!x.selectedFile || (typeof x.selectedFile == object && !x.selectedFile.name)) && (
                        <div className="form-group">
                          <div className={style.uploadBtnWrapper}>
                            <button type="button" className={style.uploadBtn}>
                              <i
                                className="fa fa-upload mr-2"
                                aria-hidden="true"
                              ></i>{" "}
                              Upload
                                <Field
                                  type="file"
                                  name="selectedFile"
                                  onChange={(e) => {
                                    handleInputChangeFile(
                                      e,
                                      i);
                                  }}
                                  title={
                                    x.selectedFile
                                      ? x.selectedFile.name
                                      : x.selectedFile
                                  }
                                />
                            </button>
                          </div>
                        </div>)}
                        <div className={`form-group ${style.uploadedText}`}>
                          {x.isNewUpload && x.selectedFile
                            ? x.selectedFile.name
                            : x.selectedFile}
                        </div>
                      </div>
                      {/* <div className="order-3 order-sm-3 order-md-2 col-sm-12 col-md-3 col-lg-3 col-xl-2">
                       
                      </div> */}
                      <div className="order-4 order-sm-4 order-md-3 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                        <div className="form-group">
                          <Field
                            className={`form-control ${style.description}`}
                            name="description"
                            placeholder="Description"
                            value={x.description}
                            onChange={(e) =>
                              handleInputChange(e, i)
                            }
                          />
                        </div>
                      </div>
                      <div
                        className={`oder-2 oder-sm-2 order-md-4 col-4 col-sm-6 col-md-1 col-lg-1 col-xl-1 ${style.pullRightIcon}`}
                      >
                        {inputList.length > 0 && (
                          <i
                            className={`fa fa-times ${style.deleteIcon}`}
                            aria-hidden="true"
                            onClick={() =>
                              handleRemoveClick(i)
                            }
                          ></i>
                        )}
                      </div>
                      <div className="order-5 order-sm-5 order-md-5 col-sm-12 col-md-12 col-lg-12 col-xl-2">
                        {inputList.length - 1 === i &&
                          inputList.length < max_upload && (
                            <button
                              onClick={handleAddClick}
                              className={style.addBtn}
                            >
                              <i
                                className="fa fa-plus mr-2"
                                aria-hidden="true"
                              ></i>
                              Add
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                ));
              })}
            <span className="error">{imageErr ? imageErr : ""}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientDocUpload;
